const r = ":host{display:inline-block}.sl-skeleton{position:relative;overflow:hidden;background-color:var(--sl-skeleton-bg,var(--sl-gray-200));animation:sl-skeleton-pulse var(--sl-skeleton-duration,1.5s) ease-in-out infinite}.sl-skeleton::after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient( 90deg,transparent,var(--sl-skeleton-shimmer,var(--sl-gray-100)),transparent );animation:sl-skeleton-shimmer var(--sl-skeleton-duration,1.5s) ease-in-out infinite;transform:translateX(-100%)}.sl-skeleton--text{border-radius:var(--sl-radius-sm);height:1em}.sl-skeleton--rectangle{border-radius:var(--sl-radius-md)}.sl-skeleton--circle{border-radius:var(--sl-radius-full)}.sl-skeleton--avatar{border-radius:var(--sl-radius-full);width:3rem;height:3rem}@keyframes sl-skeleton-pulse{0%,100%{opacity:1}50%{opacity:0.5}}@keyframes sl-skeleton-shimmer{0%{transform:translateX(-100%)}100%{transform:translateX(100%)}}";
class n extends HTMLElement {
  static get observedAttributes() {
    return ["variant", "width", "height"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this._render();
  }
  get variant() {
    return this.getAttribute("variant") || "text";
  }
  set variant(t) {
    this.setAttribute("variant", t);
  }
  get width() {
    return this.getAttribute("width") || "";
  }
  set width(t) {
    this.setAttribute("width", t);
  }
  get height() {
    return this.getAttribute("height") || "";
  }
  set height(t) {
    this.setAttribute("height", t);
  }
  _render() {
    const e = ["sl-skeleton", `sl-skeleton--${this.variant}`], s = this.width ? `width: ${this.width};` : "", i = this.height ? `height: ${this.height};` : "";
    this._shadow.innerHTML = `
      <style>${r}</style>
      <div class="${e.join(" ")}" style="${s} ${i}"></div>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-skeleton") && customElements.define("sl-skeleton", n);
export {
  n as SlSkeletonElement
};
//# sourceMappingURL=sl-skeleton.js.map
